/*
author: jimbo
vue 事件车
作用：都引入一个新的vue实例，然后通过分别调用这个实例的事件触发和监听来实现通信和参数传递。
*/

import Vue from 'vue'
const eventBus=new Vue()
export default eventBus


/*
系统现有使用事件：（使用再次加备注，避免重复命名造成的冲突）

handleChangeAdcd :  省市切换

workbenchRefresh :  工作台雨水情数据自动刷新

upateWarns :  监视预警 更新预警状态  1、关闭相关弹出框  2、更新左侧预警列表数据  3、移除地图图层元素及标注  4、如果预警是新产生的 则需更新新预警提醒框内容

upateWarnsComplex :  农村基层监视预警 更新预警状态  1、关闭相关弹出框  2、更新左侧预警列表数据  3、移除地图图层元素及标注  4、如果预警是新产生的 则需更新新预警提醒框内容

openVoice :  开启预警声音

mapRainUpdate :  监视预警 地图上雨情数据更新 需触发雨情列表数据更新

mapRiverUpdate :  监视预警 地图上河道水情数据更新 需触发河道水情列表数据更新

mapRsvrUpdate :  监视预警 地图上水库水情数据更新 需触发水库水情列表数据更新

mapWarnUpdate :  监视预警 地图上预警数据更新 需触发预警列表数据更新

riverFloodUpdate: 工作台 河道洪峰数据更新

mapImgUpdate: 监视预警 图像站数据更新

mapVideoUpdate: 监视预警 视频站数据更新

mapDeviceUpdate: 监视预警 设备运行情况数据更新

mapSoilUpdate: 监视预警 墒情数据更新
*/



// WEBPACK FOOTER //
// ./src/assets/util/eventBus.js